<template>
  <div class="container">
    <modal v-on:cancel="handleDeleteModalResultCancel()" 
           v-on:ok="handleDeleteModalResultOK()" 
           v-if="showModal" v-bind:modalText="modalText" v-bind:showButtons="'OkCancel'"></modal>    
    <div v-if="tournaments.length > 0">
      <h6 class="groupheader" v-if="topX <= tournaments.length"><font-awesome-icon icon="trophy" class="inputImage"/> tournaments found ({{ topX }} out of {{ tournaments.length }})</h6>
      <h6 class="groupheader" v-if="topX > tournaments.length"><font-awesome-icon icon="trophy" class="inputImage"/> tournaments found</h6>
      <table class="result-table">
        <tr v-for="(tournament, index) in topTournaments" :key="index" :tournament="tournament">
          <td><router-link :to="/tournaments/ + tournament.tournamentId" class="link">{{tournament.name}}</router-link></td>
          <td> {{ showDate(tournament.startDate) }} t/m {{ showDate(tournament.endDate) }}</td>
          <td class="lastCol"><a class="imgbtn" href="#" title="delete this tournament" @click="preDeleteTournament(tournament.name, tournament.tournamentId)"><font-awesome-icon icon="trash" /></a></td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>

import moment from 'moment';
import Modal from "@/components/Modal";
import {RestAPI} from "@aws-amplify/api-rest";

const apiName = 'api';
const path = '/tournament/';

export default {
  name: 'MgtTournamentsList',
  components: {Modal},
  props: {
    tournaments: Array,
    topX: Number
  },
  emits: ['tournamentListChanged'],
  data: function() {
    return {
      showingModal: false,
      modalText: "",
      deletingTournamentId: ""
    }
  },
  computed: {
    showModal() {
      return this.showingModal;
    },
    topTournaments: function() {
      if (this.tournaments.length > this.topX) {
        return this.tournaments.slice(0, this.topX);
      } else 
        return this.tournaments;
    }
  },
  methods: {
    deleteTournament() {
      let completePath = path + this.deletingTournamentId;
      let that = this;
      const localInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        response: false,
      };
      console.log('delete path: ' + completePath);
      RestAPI
        .del(apiName, completePath, localInit)
        .then(response => {
          that.$emit("tournamentListChanged");
          console.log(response);
        })
        .catch(error => {
          if (error.status !== 404) {
            console.log("ERROR", JSON.stringify(error));
          }
        });
    },

    handleDeleteModalResultCancel() {
      console.log('Action cancelled');
      this.showingModal = false;
    },

    handleDeleteModalResultOK() {
      console.log('Action ok-d ');
      this.showingModal = false;
      this.deleteTournament();
    },

    showDate: function(sDate) {
      return moment(sDate).format("DD MMM yyyy");
    },

    preDeleteTournament(name, tournamentId) {
      this.modalText = 'Weet u zeker dat u toernooi "' + name + '" wilt verwijderen?';
      this.deletingTournamentId = tournamentId;
      console.log('About to delete: '+ tournamentId);
      this.showingModal=true;
    }
  }
}
</script>

<style scoped>

a {
  text-decoration: none;
}

.link:hover {
  font-weight: bold;
}

.cardContainer {
  max-width: 100vw;
  display: grid;
  grid-gap: 1vw;
}

.result-table {
  width: calc(100% - 2vw);
  margin: 0vw 2vw 2vw 2vw;
  border: 1px solid #181818;
  border-radius: 2px;
}

tr:nth-child(odd) {
  background-color: #181818;
}
/* mobile */
@media screen and (max-width: 600px) {
  .cardContainer {
    grid-template-columns: repeat(1, 1fr);
  }
}

/* ipad */
@media screen and (min-width: 601px) and (max-width: 1280px) {
  .cardContainer {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* laptop */
@media screen and (min-width: 1281px) {
  .cardContainer {
    grid-template-columns: repeat(3, 1fr);
  }
}

</style>

